<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>

<app-alert-trocar-empresa [alertAlterarEmpresa]="showAlertTrocarEmpresa" [nomeEmpresaDestino]="nomeEmpresaDestino"
  [cnpjEmpresaDestino]="cnpjEmpresaDestino" [companyIdDestino]="companyIdDestino"
  (alertAlterarEmpresaFechou)="eventoAlertAlterarEmpresaFechou($event)">
</app-alert-trocar-empresa>

<app-header-sem-menu></app-header-sem-menu>

<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <!-- CONTEÚDO -->
  <div class="row">
    <div class="col-lg-12 mb-4 mb-lg-0">
      <div class="card">
        <div class="title-content">
          <h1 class="museo">{{titlePage}}</h1>
          @if (ehTrocaDeEmpresa) {
            <a class="museo" (click)="verificaSeMantemUsuarioNoVT()" style="cursor: pointer;">VOLTAR AO PORTAL</a>
          }
        </div>
        <p class="paragrafo mb-1 mt-2 museo opacity">Selecione a empresa matriz para ver as filiais e escolha a empresa que
        deseja acessar.</p>
        <p class="paragrafo mb-2 mt-4 museo"><strong>LISTA DE EMPRESAS</strong></p>
        <div class="input-group align-items-center col-md-8 col-xl-6 mt-3">
          <input type="text" class="form-control sombra museo"
            placeholder="Busque por nome ou CNPJ da matriz ou filial" [(ngModel)]="termoDeBusca" (input)="onTermoChange()">
          <i class="fa fa-search c-gray icone-lupa" aria-hidden="true"></i>
        </div>
        <div class="row mt-5">
          @for (item of listaDeEmpresasFilter; track item) {
            <div class="col-12">
              <div class="accordion" id="{{'accordion'+item.companyId}}">
                <div class="row">
                  <div class="col-12 delimiter"
                    [ngClass]="isCurrentCompany(item.companyId) || containsCurrentCompany(item) ? 'current-company' : ''">
                    <div class="title-accordion">
                      <button
                        class="title-content btn-icon"
                        [ngClass]="item.allowedOnParentCompany ? '' : 'notAllowed'"
                        (click)="acessarMatriz(item)"
                        >
                        <img class="icon-matriz" alt="empresa matriz">
                        <div class="ms-3">
                          <p class="paragrafo mb-1 mt-2"><strong>{{ item.socialName | camelCase }}</strong></p>
                          <p class="paragrafo mb-1 mt-2"><strong>CNPJ:</strong> {{ item.cnpj | cnpj }}</p>
                        </div>
                      </button>
                      @if (isCurrentCompany(item.companyId)) {
                        <div class="me-4"
                          style="flex-grow: 2; text-align:right;">
                          <span class="float-end museo" style="font-weight: 400; font-size: 14px; line-height: 150%; color: #696969;">Empresa Atual</span>
                        </div>
                      }
                      <button
                        class="btn-icon"
                        style="flex-grow: 1; justify-content: right;"
                        (click)="abreFechaAccordion('accordion'+item.companyId, item.companyId)"
                        aria-label="Abrir/Fechar accordion"
                        >
                        <i class="icone fa fa-angle-down c-primary icone-grande" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                  @if (item.subsidiaries.length > 0) {
                    @for (sub of item.subsidiaries; track sub) {
                      <div class="col-12 my-3 subsidiarie d-none"
                        >
                        <div class="expansive delimiter"
                          [ngClass]="isCurrentCompany(sub.companyId) ? 'current-company' : ''">
                          <div class="title-accordion">
                            <button
                              class="title-content btn-icon"
                              style="display: flex; align-items: center;"
                              (click)="acessarEmpresa(sub)"
                              >
                              <div class="ms-3">
                                <p class="paragrafo mb-1 mt-2"><strong>{{ sub.socialName | camelCase }}</strong></p>
                                <p class="paragrafo mb-1 mt-2"><strong>CNPJ:</strong> {{ sub.cnpj | cnpj }}</p>
                              </div>
                            </button>
                            @if (isCurrentCompany(sub.companyId)) {
                              <div class="me-4"
                                style="flex-grow: 1; text-align:right;">
                                <span>Empresa Atual</span>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>